import { ModelTranslator } from '@/types/ApiResponseTypes'
import { isTableFilterType, TableFilter } from '@/types/support/TicketFilterType'
import { TableFilterRequest } from '@/types/support/TicketRequestType'

class TicketFilterRequestTranslator implements ModelTranslator<Array<TableFilterRequest>> {
  convertToModel(model: any): Array<TableFilterRequest> {
    if (isTableFilterType(model)) {
      const result: Array<TableFilterRequest> = []
      model.forEach((item: TableFilter) => {
        result.push(this.formatFilter(item))
      })
      return result
    }
    return []
  }

  formatFilter(filter: TableFilter): TableFilterRequest {
    return {
      fieldName: filter.column.fieldId,
      operator: filter.operator.fieldId,
      fieldValue: String(filter.value),
    }
  }
}
export default new TicketFilterRequestTranslator()
